import { alias, deserialize, list, object, serializable } from 'serializr';

export class MondayProjectColumnModel {
  @serializable
  public id: string;
  @serializable
  public title: string;
  @serializable
  public type: string;
  @serializable
  public text: string;
  @serializable(alias('settings_str'))
  public statuses: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(MondayProjectColumnModel, input));
  }
}

export class MondayProjectGroupModel {
  @serializable
  public id: string;
  @serializable
  public title: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(MondayProjectGroupModel, input));
  }
}

export class MondayProjectModel {
  @serializable
  public id: string;
  @serializable
  public name: string;
  @serializable
  public type: string;
  @serializable(alias('columns', list(object(MondayProjectColumnModel))))
  public columns: MondayProjectColumnModel[];
  @serializable(alias('groups', list(object(MondayProjectGroupModel))))
  public groups: MondayProjectGroupModel[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(MondayProjectModel, input));
  }
}

export class MondayUserModel {
  @serializable
  public id: string;
  @serializable
  public name: string;
  @serializable(alias('photo_thumb'))
  public iconUrl: string;
  @serializable
  public email: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(MondayUserModel, input));
  }
}

export class MondayIssueModel {
  @serializable
  public id: string;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(MondayUserModel, input));
  }
}
